
//#region Imports
//#region Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//#endregion

//#region Bootstrap

import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import {
    BsDatepickerModule,
    BsDatepickerConfig,
    BsDaterangepickerConfig,
    BsLocaleService
} from 'ngx-bootstrap/datepicker';

import { NgxBootstrapDatePickerConfigService } from '@axilla/axilla-shared';

//#endregion

//#region Primeng
import { TableModule } from 'primeng/table';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
//#endregion

import { WebshopUtilsModule } from '@shared/utils/utils.module';
//#endregion


//#region Custom
import { SearchAndSelectComponent } from './search-and-select/search-and-select.component';
import { ImageContainerComponent } from './image/image-container.component';
import { ImageHightlighterTooltipComponent } from './image-highlighter/image-highlighter-tooltip.component';
import { AxillaCommonModule } from '@axilla/axilla-shared';
import {
    ThreeStateToggleComponent
} from '@app/shared/common/shop-system/common/three-state-toggle/three-state-toggle.component';
//#endregion


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ModalModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TableModule,
        WebshopUtilsModule,
        DropdownModule,
        ButtonModule,
        PaginatorModule,
        AutoCompleteModule,
        ProgressSpinnerModule,
        AxillaCommonModule
    ],
    declarations: [
        SearchAndSelectComponent,
        ImageContainerComponent,
        ImageHightlighterTooltipComponent,
        ThreeStateToggleComponent
    ],
    exports: [
        SearchAndSelectComponent,
        ImageContainerComponent,
        ThreeStateToggleComponent
    ],
    providers: [
        BsModalRef,
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
        { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale }
    ]
})
export class UblCommonModule { }
